<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          upvoted
          <a
            :alt="bookTitle"
            class="resource-link"
            :href="activity.source.url"
            :title="bookTitle"
            @click.stop
          >
            {{ bookTitle }}
          </a>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />
    </div>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';

export default {
  mixins: [
    activityMixin,
  ],
  computed: {
    bookTitle() {
      if (this.activity.source.type === 'LaunchedBookActivity') {
        return this.activity.source.source.title;
      }

      return this.activity.source.title;
    },
  },
};
</script>
